<div class="page-body-wrapper">
    <div class="row">
        <div class="col-lg-12">
            <div >
                <button  mat-raised-button color="primary"
                    (click)="openAbsenceCreateModal(true)">
                    <mat-icon class="mdc-button__icon">add</mat-icon>
                    <span class="mdc-button__label">Yeni İzin Oluştur</span>
                </button>
            </div>

            <mat-tab-group [selectedIndex]="selectedTab">
                <mat-tab label="Onay Bekleyenler" *ngIf="currentUser.manager || currentUser.hr">
                    <div class="table-responsive table-hidden-scroll" style="overflow-x:hidden">
                        <div class="row filter-wrapper">
                            <div class="col-lg-3">
                                <mat-form-field class="absence-form-field">
                                    <mat-label >İzin Türü Seçiniz</mat-label>
                                    <mat-select [(value)]="selectedAbsenceType1" class="mdc-select">
                                        <mat-option *ngFor="let absenceType of absenceTypeList" [value]="absenceType">
                                            {{absenceType.description}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                            <div class="col-lg-3">
                                <mat-form-field class="absence-form-field">
                                    <mat-label>Departman Seçiniz</mat-label>
                                    <mat-select [(value)]="selectedDepartment1">
                                        <mat-option *ngFor="let department of departmentList" [value]="department">
                                            {{department.lookupValue ? (department.lookupValue + ' - ' + department.description) : department.description}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                            <div class="col-lg-3">
                                <mat-form-field class="absence-form-field">
                                    <mat-label>Başlangıç Tarihi</mat-label>
                                    <input readonly matInput [matDatepicker]="pickerStart1"
                                        [formControl]="startDateFilterValue1" style="max-width: 160px;">
                                    <mat-datepicker-toggle matSuffix [for]="pickerStart1"></mat-datepicker-toggle>
                                    <mat-datepicker startView="multi-year" #pickerStart1></mat-datepicker>
                                </mat-form-field>
                            </div>
                            <div class="col-lg-3">
                                <mat-form-field class="absence-form-field">
                                    <mat-label>Bitiş Tarihi</mat-label>
                                    <input readonly matInput [matDatepicker]="pickerEnd1"
                                        [formControl]="endDateFilterValue1">
                                    <mat-datepicker-toggle matSuffix [for]="pickerEnd1"></mat-datepicker-toggle>
                                    <mat-datepicker #pickerEnd1 startView="multi-year"></mat-datepicker>
                                </mat-form-field>
                            </div>
                        </div>
                        <div class="row filter-wrapper">
                            <div class="col-lg-3">
                                <mat-form-field style="width: 100%;">
                                    <mat-label>Ad Soyad</mat-label>
                                    <input matInput placeholder="" [(ngModel)]="searchFullName1">
                                </mat-form-field>
                            </div>
                            <div class="col-lg-3 table-header-button-wrapper">
                                <button mat-raised-button color="warn" class="button-small"
                                    (click)="filterGrid(0, 'ONAY_BEKLEYENLER')">
                                    Filtrele
                                </button>
                                <button mat-stroked-button class="button-small"
                                    (click)="clearfilterGrid(0, 'ONAY_BEKLEYENLER')">
                                    Temizle
                                </button>
                                <button mat-raised-button class="button-small"
                                    style="background-color: #28a745; color: white;" matTooltip="Excele aktar"
                                    (click)="reportTab(0, 'ONAY_BEKLEYENLER')">
                                    Excel'e Aktar
                                </button>
                            </div>
                        </div>

                        <mat-table matTableExporter #waitingsExporter="matTableExporter" [hiddenColumns]="[0,9]"
                            class="lessons-table mat-elevation-z8 mdc-data-table__table" #WaitingSort="matSort" matSort
                            [dataSource]="dsWaitings" (matSortChange)="sortChangeOfWaitings($event)">
                            <!-- Checkbox Column -->
                            <ng-container matColumnDef="select">
                                <th mat-header-cell *matHeaderCellDef class="table-checkbox">
                                    <mat-checkbox (change)="$event ? masterToggle() : null"
                                        [checked]="selection.hasValue() && isAllSelected()"
                                        [indeterminate]="selection.hasValue() && !isAllSelected()">
                                    </mat-checkbox>
                                </th>
                                <td mat-cell *matCellDef="let row" class="table-checkbox">
                                    <mat-checkbox (click)="$event.stopPropagation()"
                                        (change)="$event ? selection.toggle(row) : null"
                                        [checked]="selection.isSelected(row)">
                                    </mat-checkbox>
                                </td>
                            </ng-container>
                            <!-- <ng-container matColumnDef="isCompleted">
                                <mat-header-cell *matHeaderCellDef style="flex-grow: 0"> Durum </mat-header-cell>
                                <mat-cell *matCellDef="let element" style="flex-grow: 0">{{element.isCompleted == 1 ? 'onay' : element.isCompleted == -1 ? 'red' : 'bekliyor'}}</mat-cell>
                            </ng-container>-->
                            <ng-container matColumnDef="name">
                                <mat-header-cell *matHeaderCellDef mat-sort-header> Adı Soyadı </mat-header-cell>
                                <mat-cell *matCellDef="let element">{{element.name}} {{element.surname}}</mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="departmentName">
                                <mat-header-cell *matHeaderCellDef> Departman </mat-header-cell>
                                <mat-cell *matCellDef="let element"> {{element.departmentName}} </mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="absenceTypeName">
                                <mat-header-cell *matHeaderCellDef> İzin Türü </mat-header-cell>
                                <mat-cell *matCellDef="let element"> {{element.absenceTypeName}} </mat-cell>
                            </ng-container>

                            <ng-container matColumnDef="absenceDay">
                                <mat-header-cell *matHeaderCellDef style="flex-grow: 0.5"> İzin <br> Süresi
                                </mat-header-cell>
                                <mat-cell *matCellDef="let element" style="flex-grow: 0.5"> {{element.absenceDay}}
                                </mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="freeDayAmount">
                                <mat-header-cell *matHeaderCellDef style="flex-grow: 0.5"> Tatil <br> Günü
                                </mat-header-cell>
                                <mat-cell *matCellDef="let element" style="flex-grow: 0.5"> {{element.freeDayAmount}}
                                </mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="absenceStartDate">
                                <mat-header-cell *matHeaderCellDef mat-sort-header style="flex-grow: 0.75"> Başlangıç
                                </mat-header-cell>
                                <mat-cell *matCellDef="let element" style="flex-grow: 0.75">
                                    {{element.absenceStartDate}} </mat-cell>
                            </ng-container>

                            <ng-container matColumnDef="absenceEndDate">
                                <mat-header-cell *matHeaderCellDef mat-sort-header style="flex-grow: 0.75">Bitiş
                                </mat-header-cell>
                                <mat-cell *matCellDef="let element" style="flex-grow: 0.75"> {{element.absenceEndDate}}
                                </mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="description">
                                <mat-header-cell *matHeaderCellDef style="flex-grow: 1.25"> Açıklama</mat-header-cell>
                                <mat-cell *matCellDef="let element" class="long-text-content" style="flex-grow: 1.25">
                                    <span class="text-truncate">{{element.description}}</span> </mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="actions">
                                <mat-header-cell *matHeaderCellDef class="actions-mat-cell">İşlemler</mat-header-cell>
                                <mat-cell *matCellDef="let element" class="actions-mat-cell">
                                    <div class="action-buttons-container">
                                        <button mat-icon-button 
                                            matTooltip="Güncelle"
                                            *ngIf="(element.isCompleted == null || element.isCompleted == 0) && element.anyManagerApproved == 0"
                                            class="action-button edit-button" 
                                            (click)="openUpdateModal(element, 1)">
                                            <mat-icon>edit</mat-icon>
                                        </button>
                                        <button mat-icon-button 
                                            matTooltip="Yenile ve Tekrar Gönder"
                                            *ngIf="element.isCompleted == -1" 
                                            class="action-button refresh-button"
                                            (click)="openAbsenceCreateModal(false, element)">
                                            <mat-icon>cached</mat-icon>
                                        </button>
                                        <button mat-icon-button 
                                            matTooltip="Detay"
                                            class="action-button detail-button"
                                            (click)="openDetail(element)">
                                            <mat-icon>insert_comment</mat-icon>
                                        </button>
                                        <button mat-icon-button 
                                            matTooltip="İzni Silin"
                                            *ngIf="element.isCompleted == null && element.anyManagerApproved == 0"
                                            class="action-button delete-button"
                                            (click)="openDeleteModal(element)">
                                            <mat-icon>delete_forever</mat-icon>
                                        </button>
                                        <button mat-icon-button 
                                            matTooltip="Onayla"
                                            *ngIf="element.isCompleted == null || element.isCompleted == 0"
                                            class="action-button approve-button"
                                            (click)="openApproveModal(element)">
                                            <mat-icon>check_circle</mat-icon>
                                        </button>
                                        <button mat-icon-button 
                                            matTooltip="Reddet"
                                            *ngIf="element.isCompleted == null || element.isCompleted == 0"
                                            class="action-button reject-button"
                                            (click)="openRejectModal(element)">
                                            <mat-icon>highlight_off</mat-icon>
                                        </button>
                                    </div>
                                    
                                </mat-cell>
                            </ng-container>
                            <mat-header-row *matHeaderRowDef="displayedColumnsWaiting"></mat-header-row>
                            <mat-row *matRowDef="let row; columns: displayedColumnsWaiting"></mat-row>

                        </mat-table>
                        <mat-paginator [pageSizeOptions]="[20]" (page)="pageEventOfWaitings($event)"
                            #waitingsPaginator='matPaginator' showFirstLastButtons></mat-paginator>
                        <div class="action-button-wrapper">
                            <button [disabled]="!selection.hasValue()" mat-raised-button color="warn"
                                class="button-with-icon" (click)="openRejectSelectedModal()">
                                <mat-icon>close</mat-icon>
                                Reddet
                            </button>
                            <button [disabled]="!selection.hasValue()" mat-raised-button color="primary"
                                class="button-with-icon" (click)="openApproveSelectedModal()">
                                <mat-icon>check</mat-icon>
                                Onayla
                            </button>
                        </div>
                    </div>
                </mat-tab>
                <mat-tab label="İzinlerim">

                    <div class="table-responsive table-hidden-scroll" style="overflow-x:hidden">

                        <div class="row filter-wrapper">
                            <div class="col-lg-2">
                                <mat-form-field class="absence-form-field">
                                    <mat-label>İzin Türü Seçiniz</mat-label>
                                    <mat-select [(value)]="selectedAbsenceType2">
                                        <mat-option *ngFor="let absenceType of absenceTypeList" [value]="absenceType">
                                            {{absenceType.description}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                            <div class="col-lg-3">
                                <mat-form-field class="absence-form-field">
                                    <mat-label>Departman Seçiniz</mat-label>
                                    <mat-select [(value)]="selectedDepartment2">
                                        <mat-option *ngFor="let department of departmentList" [value]="department">
                                            {{department.lookupValue ? (department.lookupValue + ' - ' + department.description) : department.description}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                            <div class="col-lg-2" style="margin-right:20px">
                                <mat-form-field class="absence-form-field">
                                    <mat-label>Başlangıç Tarihi</mat-label>
                                    <input readonly matInput [matDatepicker]="pickerStart2"
                                        [formControl]="startDateFilterValue2" style="max-width: 160px;">
                                    <mat-datepicker-toggle matSuffix [for]="pickerStart2"></mat-datepicker-toggle>
                                    <mat-datepicker startView="multi-year" #pickerStart2></mat-datepicker>
                                </mat-form-field>
                            </div>
                            <div class="col-lg-2" style="margin-right:20px">
                                <mat-form-field class="absence-form-field">
                                    <mat-label>Bitiş Tarihi</mat-label>
                                    <input readonly matInput [matDatepicker]="pickerEnd2"
                                        [formControl]="endDateFilterValue2">
                                    <mat-datepicker-toggle matSuffix [for]="pickerEnd2"></mat-datepicker-toggle>
                                    <mat-datepicker #pickerEnd2 startView="multi-year"></mat-datepicker>
                                </mat-form-field>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-lg-3">
                                <mat-form-field style="width: 100%;">
                                    <mat-label>Ad Soyad</mat-label>
                                    <input matInput placeholder="" [(ngModel)]="searchFullName2">
                                </mat-form-field>
                            </div>
                            <div class="col-lg-4 table-header-button-wrapper">
                                <button mat-raised-button color="warn" (click)="filterGrid(1, 'TALEPLERIM')"
                                    style="margin-right: 5px;">Filtrele</button>
                                <button mat-raised-button color="link" (click)="clearfilterGrid(1, 'TALEPLERIM')"
                                    style="margin-right: 5px;">Temizle</button>
                                <button mat-raised-button class="button-small"
                                    style="background-color: #28a745; color: white;" matTooltip="Excele aktar"
                                    (click)="reportTab(0, 'TALEPLERIM')">
                                    Excel'e Aktar
                                </button>
                            </div>
                        </div>

                        <mat-table matTableExporter #exporter2="matTableExporter" [hiddenColumns]="[9]" id="taleplerim"
                            #MyRequestSort="matSort" matSort class="lessons-table mat-elevation-z8"
                            [dataSource]="dsMyRequest" (matSortChange)="sortChangeOfMyRequest($event)">
                            <ng-container matColumnDef="isCompleted">
                                <mat-header-cell *matHeaderCellDef> Durum </mat-header-cell>
                                <mat-cell *matCellDef="let element" [ngStyle]="{'color' : element.isCompleted == 1 ? 'green' :
                                                                element.isCompleted == -1 ? 'red' :
                                                                'gray'}">
                                    {{element.isCompleted == 1 ? 'Onaylandı' : element.isCompleted == -1 ? 'Reddedildi'
                                    : 'Bekliyor'}}
                                </mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="name">
                                <mat-header-cell *matHeaderCellDef mat-sort-header> Adı Soyadı </mat-header-cell>
                                <mat-cell *matCellDef="let element">{{element.name}} {{element.surname}}</mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="departmentName">
                                <mat-header-cell *matHeaderCellDef> Departman </mat-header-cell>
                                <mat-cell *matCellDef="let element"> {{element.departmentName}} </mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="absenceTypeName">
                                <mat-header-cell *matHeaderCellDef> İzin Türü </mat-header-cell>
                                <mat-cell *matCellDef="let element"> {{element.absenceTypeName}} </mat-cell>
                            </ng-container>

                            <ng-container matColumnDef="absenceDay">
                                <mat-header-cell *matHeaderCellDef style="flex-grow: 0.5"> İzin <br> Süresi
                                </mat-header-cell>
                                <mat-cell *matCellDef="let element" style="flex-grow: 0.5"> {{element.absenceDay}}
                                </mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="freeDayAmount">
                                <mat-header-cell *matHeaderCellDef style="flex-grow: 0.5"> Tatil <br> Günü
                                </mat-header-cell>
                                <mat-cell *matCellDef="let element" style="flex-grow: 0.5"> {{element.freeDayAmount}}
                                </mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="absenceStartDate">
                                <mat-header-cell *matHeaderCellDef mat-sort-header> Başlangıç </mat-header-cell>
                                <mat-cell *matCellDef="let element"> {{element.absenceStartDate}} </mat-cell>
                            </ng-container>

                            <ng-container matColumnDef="absenceEndDate">
                                <mat-header-cell *matHeaderCellDef mat-sort-header> Bitiş </mat-header-cell>
                                <mat-cell *matCellDef="let element"> {{element.absenceEndDate}} </mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="description">
                                <mat-header-cell *matHeaderCellDef style="flex-grow: 2"> Açıklama</mat-header-cell>
                                <mat-cell *matCellDef="let element" style="flex-grow: 2" class="long-text-content"><span
                                        class="text-truncate">{{element.description}}</span> </mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="actions">
                                <mat-header-cell *matHeaderCellDef class="actions-mat-cell">İşlemler</mat-header-cell>
                                <mat-cell *matCellDef="let element" class="actions-mat-cell">
                                    <div class="action-buttons-container">
                                        <button mat-icon-button 
                                            matTooltip="Güncelle"
                                            *ngIf="(element.isCompleted == null || element.isCompleted == 0) && element.anyManagerApproved == 0"
                                            class="action-button edit-button"
                                            (click)="openUpdateModal(element, 2)">
                                            <mat-icon [ngStyle]="{'color': '#1976d2'}">edit</mat-icon>
                                        </button>
                                        <button mat-icon-button 
                                            matTooltip="Yenile ve Tekrar Gönder"
                                            *ngIf="element.isCompleted == -1"
                                            class="action-button refresh-button"
                                            (click)="openAbsenceCreateModal(false, element)">
                                            <mat-icon [ngStyle]="{'color': '#fb8c00'}">cached</mat-icon>
                                        </button>
                                        <button mat-icon-button 
                                            matTooltip="Detay"
                                            class="action-button detail-button"
                                            (click)="openDetail(element)">
                                            <mat-icon [ngStyle]="{'color': '#1976d2'}">description</mat-icon>
                                        </button>
                                        <button mat-icon-button 
                                            matTooltip="İzni Silin"
                                            *ngIf="element.isCompleted == null && element.anyManagerApproved == 0"
                                            class="action-button delete-button"
                                            (click)="openDeleteModal(element)">
                                            <mat-icon [ngStyle]="{'color': '#dc3545'}">delete_forever</mat-icon>
                                        </button>
                                    </div>
                                </mat-cell>
                            </ng-container>
                            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                            <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>

                        </mat-table>
                        <mat-paginator [pageSizeOptions]="[20]" (page)="pageEventOfMyRequests($event)"
                            #myRequestPaginator="matPaginator" showFirstLastButtons></mat-paginator>
                    </div>
                </mat-tab>
                <mat-tab label="Onayladıklarım" *ngIf="currentUser.manager || currentUser.hr">
                    <div class="table-responsive table-hidden-scroll" style="overflow-x:hidden">

                        <div class="row filter-wrapper">
                            <div class="col-lg-2">
                                <mat-form-field class="absence-form-field">
                                    <mat-label>İzin Türü Seçiniz</mat-label>
                                    <mat-select [(value)]="selectedAbsenceType3">
                                        <mat-option *ngFor="let absenceType of absenceTypeList" [value]="absenceType">
                                            {{absenceType.description}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                            <div class="col-lg-3">
                                <mat-form-field class="absence-form-field">
                                    <mat-label>Departman Seçiniz</mat-label>
                                    <mat-select [(value)]="selectedDepartment3">
                                        <mat-option *ngFor="let department of departmentList" [value]="department">
                                            {{department.lookupValue ? (department.lookupValue + ' - ' + department.description) : department.description}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                            <div class="col-lg-2" style="margin-right:20px">
                                <mat-form-field class="absence-form-field">
                                    <mat-label>Başlangıç Tarihi</mat-label>
                                    <input readonly matInput [matDatepicker]="pickerStart3"
                                        [formControl]="startDateFilterValue3" style="max-width: 160px;">
                                    <mat-datepicker-toggle matSuffix [for]="pickerStart3"></mat-datepicker-toggle>
                                    <mat-datepicker startView="multi-year" #pickerStart3></mat-datepicker>
                                </mat-form-field>
                            </div>
                            <div class="col-lg-2" style="margin-right:20px">
                                <mat-form-field class="absence-form-field">
                                    <mat-label>Bitiş Tarihi</mat-label>
                                    <input readonly matInput [matDatepicker]="pickerEnd3"
                                        [formControl]="endDateFilterValue3">
                                    <mat-datepicker-toggle matSuffix [for]="pickerEnd3"></mat-datepicker-toggle>
                                    <mat-datepicker #pickerEnd3 startView="multi-year"></mat-datepicker>
                                </mat-form-field>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-lg-3">
                                <mat-form-field style="width: 100%;">
                                    <mat-label>Ad Soyad</mat-label>
                                    <input matInput placeholder="" [(ngModel)]="searchFullName3">
                                </mat-form-field>
                            </div>
                            <div class="col-lg-4 table-header-button-wrapper">
                                <button mat-raised-button color="warn" (click)="filterGrid(2, 'ONAYLADIKLARIM')"
                                    style="margin-right: 5px;">Filtrele</button>
                                <button mat-raised-button color="link" (click)="clearfilterGrid(2, 'ONAYLADIKLARIM')"
                                    style="margin-right: 5px;">Temizle</button>
                                <button mat-raised-button class="button-small"
                                    style="background-color: #28a745; color: white;" matTooltip="Excele aktar"
                                    (click)="reportTab(0, 'ONAYLADIKLARIM')">
                                    Excel'e Aktar
                                </button>
                            </div>
                        </div>

                        <mat-table matTableExporter #exporter3="matTableExporter" [hiddenColumns]="[9]"
                            #ApprovalSort="matSort" matSort class="lessons-table mat-elevation-z8"
                            [dataSource]="dsMyApprovals" (matSortChange)="sortChangeOfApprovals($event)">
                            <ng-container matColumnDef="isCompleted">
                                <mat-header-cell *matHeaderCellDef> Durum </mat-header-cell>
                                <mat-cell *matCellDef="let element" [ngStyle]="{'color' : element.isCompleted == 1 ? 'green' :
                                                                element.isCompleted == -1 ? 'red' :
                                                                'gray'}">
                                    {{element.isCompleted == 1 ? 'Onaylandı' : element.isCompleted == -1 ? 'Reddedildi'
                                    : 'Bekliyor'}}
                                </mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="name">
                                <mat-header-cell *matHeaderCellDef mat-sort-header> Adı Soyadı </mat-header-cell>
                                <mat-cell *matCellDef="let element">{{element.name}} {{element.surname}}</mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="departmentName">
                                <mat-header-cell *matHeaderCellDef> Departman </mat-header-cell>
                                <mat-cell *matCellDef="let element"> {{element.departmentName}} </mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="absenceTypeName">
                                <mat-header-cell *matHeaderCellDef> İzin Türü </mat-header-cell>
                                <mat-cell *matCellDef="let element"> {{element.absenceTypeName}} </mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="absenceDay">
                                <mat-header-cell *matHeaderCellDef style="flex-grow: 0.5"> İzin <br> Süresi
                                </mat-header-cell>
                                <mat-cell *matCellDef="let element" style="flex-grow: 0.5"> {{element.absenceDay}}
                                </mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="freeDayAmount">
                                <mat-header-cell *matHeaderCellDef style="flex-grow: 0.5"> Tatil <br> Günü
                                </mat-header-cell>
                                <mat-cell *matCellDef="let element" style="flex-grow: 0.5"> {{element.freeDayAmount}}
                                </mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="absenceStartDate">
                                <mat-header-cell *matHeaderCellDef mat-sort-header> Başlangıç </mat-header-cell>
                                <mat-cell *matCellDef="let element"> {{element.absenceStartDate}} </mat-cell>
                            </ng-container>

                            <ng-container matColumnDef="absenceEndDate">
                                <mat-header-cell *matHeaderCellDef mat-sort-header>Bitiş </mat-header-cell>
                                <mat-cell *matCellDef="let element"> {{element.absenceEndDate}} </mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="description">
                                <mat-header-cell *matHeaderCellDef> Açıklama</mat-header-cell>
                                <mat-cell *matCellDef="let element" class="long-text-content"><span
                                        class="text-truncate">{{element.description}}</span> </mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="actions">
                                <mat-header-cell *matHeaderCellDef class="actions-mat-cell">İşlemler</mat-header-cell>
                                <mat-cell *matCellDef="let element" class="actions-mat-cell">
                                    <div class="action-buttons-container">
                                        <button mat-icon-button 
                                            matTooltip="Detay"
                                            class="action-button detail-button"
                                            (click)="openDetail(element)">
                                            <mat-icon [ngStyle]="{'color': '#1976d2'}">insert_comment</mat-icon>
                                        </button>
                                    </div>
                                </mat-cell>
                            </ng-container>
                            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                            <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>

                        </mat-table>
                        <mat-paginator [pageSizeOptions]="[20]" (page)="pageEventOfApprovals($event)"
                            #myApprovalsPaginator='matPaginator' showFirstLastButtons></mat-paginator>
                    </div>
                </mat-tab>
                <mat-tab label="Reddettiklerim" *ngIf="currentUser.manager || currentUser.hr">
                    <div class="table-responsive table-hidden-scroll" style="overflow-x:hidden">

                        <div class="row filter-wrapper">
                            <div class="col-lg-2">
                                <mat-form-field class="absence-form-field">
                                    <mat-label>İzin Türü Seçiniz</mat-label>
                                    <mat-select [(value)]="selectedAbsenceType4">
                                        <mat-option *ngFor="let absenceType of absenceTypeList" [value]="absenceType">
                                            {{absenceType.description}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                            <div class="col-lg-3">
                                <mat-form-field class="absence-form-field">
                                    <mat-label>Departman Seçiniz</mat-label>
                                    <mat-select [(value)]="selectedDepartment4">
                                        <mat-option *ngFor="let department of departmentList" [value]="department">
                                            {{department.lookupValue ? (department.lookupValue + ' - ' + department.description) : department.description}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                            <div class="col-lg-2" style="margin-right:20px">
                                <mat-form-field class="absence-form-field">
                                    <mat-label>Başlangıç Tarihi</mat-label>
                                    <input readonly matInput [matDatepicker]="pickerStart4"
                                        [formControl]="startDateFilterValue4" style="max-width: 160px;">
                                    <mat-datepicker-toggle matSuffix [for]="pickerStart4"></mat-datepicker-toggle>
                                    <mat-datepicker startView="multi-year" #pickerStart4></mat-datepicker>
                                </mat-form-field>
                            </div>
                            <div class="col-lg-2" style="margin-right:20px">
                                <mat-form-field class="absence-form-field">
                                    <mat-label>Bitiş Tarihi</mat-label>
                                    <input readonly matInput [matDatepicker]="pickerEnd4"
                                        [formControl]="endDateFilterValue4">
                                    <mat-datepicker-toggle matSuffix [for]="pickerEnd4"></mat-datepicker-toggle>
                                    <mat-datepicker #pickerEnd4 startView="multi-year"></mat-datepicker>
                                </mat-form-field>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-lg-3">
                                <mat-form-field style="width: 100%;">
                                    <mat-label>Ad Soyad</mat-label>
                                    <input matInput placeholder="" [(ngModel)]="searchFullName4">
                                </mat-form-field>
                            </div>
                            <div class="col-lg-4 table-header-button-wrapper">
                                <button mat-raised-button color="warn" (click)="filterGrid(3, 'REDDETTIKLERIM')"
                                    style="margin-right: 5px;">Filtrele</button>
                                <button mat-raised-button color="link" (click)="clearfilterGrid(3, 'REDDETTIKLERIM')"
                                    style="margin-right: 5px;">Temizle</button>
                                <button mat-raised-button class="button-small"
                                    style="background-color: #28a745; color: white;" matTooltip="Excele aktar"
                                    (click)="reportTab(0, 'REDDETTIKLERIM')">
                                    Excel'e Aktar
                                </button>
                            </div>
                        </div>

                        <mat-table matTableExporter #exporter4="matTableExporter" [hiddenColumns]="[9]"
                            #RejectSort="matSort" matSort class="lessons-table mat-elevation-z8"
                            [dataSource]="dsRejects" (matSortChange)="sortChangeOfRejects($event)">
                            <ng-container matColumnDef="isCompleted">
                                <mat-header-cell *matHeaderCellDef> Durum </mat-header-cell>
                                <mat-cell *matCellDef="let element" [ngStyle]="{'color' : element.isCompleted == 1 ? 'green' :
                                                                element.isCompleted == -1 ? 'red' :
                                                                'gray'}">
                                    {{element.isCompleted == 1 ? 'Onaylandı' : element.isCompleted == -1 ? 'Reddedildi'
                                    : 'Bekliyor'}}
                                </mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="name">
                                <mat-header-cell *matHeaderCellDef mat-sort-header> Adı Soyadı </mat-header-cell>
                                <mat-cell *matCellDef="let element">{{element.name}} {{element.surname}}</mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="departmentName">
                                <mat-header-cell *matHeaderCellDef> Departman </mat-header-cell>
                                <mat-cell *matCellDef="let element"> {{element.departmentName}} </mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="absenceTypeName">
                                <mat-header-cell *matHeaderCellDef> İzin Türü </mat-header-cell>
                                <mat-cell *matCellDef="let element"> {{element.absenceTypeName}} </mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="absenceDay">
                                <mat-header-cell *matHeaderCellDef style="flex-grow: 0.5"> İzin <br> Süresi
                                </mat-header-cell>
                                <mat-cell *matCellDef="let element" style="flex-grow: 0.5"> {{element.absenceDay}}
                                </mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="freeDayAmount">
                                <mat-header-cell *matHeaderCellDef style="flex-grow: 0.5"> Tatil <br> Günü
                                </mat-header-cell>
                                <mat-cell *matCellDef="let element" style="flex-grow: 0.5"> {{element.freeDayAmount}}
                                </mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="absenceStartDate">
                                <mat-header-cell *matHeaderCellDef mat-sort-header> Başlangıç </mat-header-cell>
                                <mat-cell *matCellDef="let element"> {{element.absenceStartDate}} </mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="absenceEndDate">
                                <mat-header-cell *matHeaderCellDef mat-sort-header>Bitiş </mat-header-cell>
                                <mat-cell *matCellDef="let element"> {{element.absenceEndDate}} </mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="description">
                                <mat-header-cell *matHeaderCellDef> Açıklama</mat-header-cell>
                                <mat-cell *matCellDef="let element" class="long-text-content"><span
                                        class="text-truncate">{{element.description}}</span> </mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="actions">
                                <mat-header-cell *matHeaderCellDef class="actions-mat-cell">İşlemler</mat-header-cell>
                                <mat-cell *matCellDef="let element" class="actions-mat-cell">
                                    <div class="action-buttons-container">
                                        <button mat-icon-button 
                                            matTooltip="Detay"
                                            class="action-button detail-button"
                                            (click)="openDetail(element)">
                                            <mat-icon [ngStyle]="{'color': '#1976d2'}">description</mat-icon>
                                        </button>
                                    </div>
                                </mat-cell>
                            </ng-container>
                            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                            <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
                        </mat-table>
                        <mat-paginator [pageSizeOptions]="[20]" (page)="pageEventOfRejects($event)"
                            #rejectsPaginator='matPaginator' showFirstLastButtons></mat-paginator>
                    </div>
                </mat-tab>
                <mat-tab label="Tüm İzinler" *ngIf="currentUser.manager || currentUser.hr">
                    <div class="table-responsive table-hidden-scroll" style="overflow-x:hidden">

                        <div class="row filter-wrapper">
                            <div class="col-lg-2">
                                <mat-form-field class="absence-form-field">
                                    <mat-label>İzin Türü Seçiniz</mat-label>
                                    <mat-select [(value)]="selectedAbsenceType5">
                                        <mat-option *ngFor="let absenceType of absenceTypeList" [value]="absenceType">
                                            {{absenceType.description}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                            <div class="col-lg-3">
                                <mat-form-field class="absence-form-field">
                                    <mat-label>Departman Seçiniz</mat-label>
                                    <mat-select [(value)]="selectedDepartment5">
                                        <mat-option *ngFor="let department of departmentList" [value]="department">
                                            {{department.lookupValue ? (department.lookupValue + ' - ' + department.description) : department.description}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                            <div class="col-lg-2">
                                <mat-form-field class="overtime-form-field">
                                    <mat-label>Durum Seçiniz</mat-label>
                                    <mat-select [(value)]="selectedStatu5">
                                        <mat-option *ngFor="let statu of StatuList" [value]="statu">
                                            {{statu.description}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                            <div class="col-lg-2" style="margin-right:20px">
                                <mat-form-field class="absence-form-field">
                                    <mat-label>Başlangıç Tarihi</mat-label>
                                    <input readonly matInput [matDatepicker]="pickerStart5"
                                        [formControl]="startDateFilterValue5" style="max-width: 160px;">
                                    <mat-datepicker-toggle matSuffix [for]="pickerStart5"></mat-datepicker-toggle>
                                    <mat-datepicker startView="multi-year" #pickerStart5></mat-datepicker>
                                </mat-form-field>
                            </div>
                            <div class="col-lg-2" style="margin-right:20px">
                                <mat-form-field class="absence-form-field">
                                    <mat-label>Bitiş Tarihi</mat-label>
                                    <input readonly matInput [matDatepicker]="pickerEnd5"
                                        [formControl]="endDateFilterValue5">
                                    <mat-datepicker-toggle matSuffix [for]="pickerEnd5"></mat-datepicker-toggle>
                                    <mat-datepicker #pickerEnd5 startView="multi-year"></mat-datepicker>
                                </mat-form-field>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-lg-3">
                                <mat-form-field style="width: 100%;">
                                    <mat-label>Ad Soyad</mat-label>
                                    <input matInput placeholder="" [(ngModel)]="searchFullName5">
                                </mat-form-field>
                            </div>
                            <div class="col-lg-4 table-header-button-wrapper">
                                <button mat-raised-button color="warn" (click)="filterGrid(4, 'TUMIZINLER')"
                                    style="margin-right: 5px;">Filtrele</button>
                                <button mat-raised-button color="link" (click)="clearfilterGrid(4, 'TUMIZINLER')"
                                    style="margin-right: 5px;">Temizle</button>
                                <button mat-raised-button class="button-small"
                                    style="background-color: #28a745; color: white;" matTooltip="Excele aktar"
                                    (click)="reportTab(0, 'TUMIZINLER')">
                                    Excel'e Aktar
                                </button>
                            </div>
                        </div>

                        <mat-table matTableExporter #exporter4="matTableExporter" [hiddenColumns]="[9]"
                            #AllSort="matSort" matSort class="lessons-table mat-elevation-z8" [dataSource]="dsAll"
                            (matSortChange)="sortChangeOfAll($event)">
                            <ng-container matColumnDef="isCompleted">
                                <mat-header-cell *matHeaderCellDef> Durum </mat-header-cell>
                                <mat-cell *matCellDef="let element" [ngStyle]="{'color' : element.isCompleted == 1 ? 'green' :
                                                                element.isCompleted == -1 ? 'red' :
                                                                'gray'}">
                                    {{element.isCompleted == 1 ? 'Onaylandı' : element.isCompleted == -1 ? 'Reddedildi'
                                    : 'Bekliyor'}}
                                </mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="name">
                                <mat-header-cell *matHeaderCellDef mat-sort-header> Adı Soyadı </mat-header-cell>
                                <mat-cell *matCellDef="let element">{{element.name}} {{element.surname}}</mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="departmentName">
                                <mat-header-cell *matHeaderCellDef> Departman </mat-header-cell>
                                <mat-cell *matCellDef="let element"> {{element.departmentName}} </mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="absenceTypeName">
                                <mat-header-cell *matHeaderCellDef> İzin Türü </mat-header-cell>
                                <mat-cell *matCellDef="let element"> {{element.absenceTypeName}} </mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="absenceDay">
                                <mat-header-cell *matHeaderCellDef style="flex-grow: 0.5"> İzin <br> Süresi
                                </mat-header-cell>
                                <mat-cell *matCellDef="let element" style="flex-grow: 0.5"> {{element.absenceDay}}
                                </mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="freeDayAmount">
                                <mat-header-cell *matHeaderCellDef style="flex-grow: 0.5"> Tatil <br> Günü
                                </mat-header-cell>
                                <mat-cell *matCellDef="let element" style="flex-grow: 0.5"> {{element.freeDayAmount}}
                                </mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="absenceStartDate">
                                <mat-header-cell *matHeaderCellDef mat-sort-header> Başlangıç </mat-header-cell>
                                <mat-cell *matCellDef="let element"> {{element.absenceStartDate}} </mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="absenceEndDate">
                                <mat-header-cell *matHeaderCellDef mat-sort-header>Bitiş </mat-header-cell>
                                <mat-cell *matCellDef="let element"> {{element.absenceEndDate}} </mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="description">
                                <mat-header-cell *matHeaderCellDef> Açıklama</mat-header-cell>
                                <mat-cell *matCellDef="let element" class="long-text-content"><span
                                        class="text-truncate">{{element.description}}</span> </mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="actions">
                                <mat-header-cell *matHeaderCellDef class="actions-mat-cell">İşlemler</mat-header-cell>
                                <mat-cell *matCellDef="let element" class="actions-mat-cell">
                                    <div class="action-buttons-container">
                                        <button *ngIf="(currentUser.hr || currentUser.selectedRole.name === 'ROLE_ADMIN') &&
                                                   (element.isCompleted == 1 || element.isCompleted == -1)"
                                            mat-icon-button
                                            matTooltip="Güncelle"
                                            class="action-button edit-button"
                                            (click)="openUpdateModal(element, 5)">
                                            <mat-icon [ngStyle]="{'color': '#1976d2'}">edit</mat-icon>
                                        </button>
                                    </div>
                                </mat-cell>
                            </ng-container>
                            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                            <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
                        </mat-table>
                        <mat-paginator [pageSizeOptions]="[20]" (page)="pageEventOfAll($event)"
                            #allPaginator="matPaginator" showFirstLastButtons>
                        </mat-paginator>
                    </div>
                </mat-tab>
            </mat-tab-group>
        </div>
    </div>
</div>